<template>
  <Container type="card-full">
      <div v-loading="loading">
          <el-button @click="remindProject" type='primary'>竞价提醒</el-button>
      </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import E from 'wangeditor'
  import config from '../../assets/config'
  import uploadFile from '../common/uploadFile'
  import common from '@/mixin/common'
  import dayjs from 'dayjs'

  export default {
    name: "jjtx",
    mixins: [common],
    data () {
      return {
          loading:false
      }
    },
    created () {
    },
    async activated () {
    },
    mounted () {
    },
    watch: {
    },
    filters: {},
    components: {},
    computed: {
    },
    deactivated () {
    },
    methods: {
        async remindProject(){
          this.$confirm('是否推送?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            let model = {}
            model.week = dayjs(new Date()).get('day')
            model.cosid = this.$store.getters.loginUser.cosid
            if(+model.week === 5)
                model.endTime = dayjs(new Date()).add(4, 'day').format('YYYY-MM-D')
            else 
                model.endTime = dayjs(new Date()).add(1, 'day').format('YYYY-MM-D')
            let data = await request({
                url: '/info/rush/remindProject',
                method: "post",
                data: model
            })
            if(+data.issuccess === 1){
                this.$message.success('推送成功')
                return
            }
            }).catch(() => {
        })
        }
    }
  }
</script>

<style lang="scss" scoped>
</style>

